{
  "drawMoreButton": "draw more fields",
  "drawPolygonInstructions": "Draw your polygon by tapping the map.",
  "fieldLabelsToggle": "Show/hide field labels",
  "fieldTypePolygon": "Polygon",
  "helpBodyText": "Create fields to represent the areas of your farm. Fields are used to track equipment and irrigation events.",
  "helpTitle": "About Creating Fields",
  "linkTo": "New Field",
  "manageFieldButton": "Manage Field",
  "notEnoughPoints": "Make sure your field has at least 3 points and is closed.",
  "restartButtonText": "Restart",
  "retartButton": "Start Over",
  "setNameInstructions": "Enter a name for your field.",
  "setRowDirectionInstructions": "Use the slider to set the row direction of your field.",
  "successInstructions": "Your field has been created.",
  "title": "New Field",
  "undoButtonText": "Undo"
}
